module.exports = __webpack_public_path__ + "img/red_039.56dfc46d.png";